import service from './service'; // 获取 国际区号

export function getCountryCode(params) {
  return service({
    url: 'getCountryCode',
    method: 'get',
    params: params
  });
} // 获取图片验证码【如忘记密码，手机验证码登录】

export function createPictureCode(params) {
  return service({
    responseType: 'arraybuffer',
    url: 'v1/picture/createPictureCode',
    method: 'get',
    params: params
  });
} // 图片验证码校验

export function checkPictureCode(data) {
  return service({
    url: 'v1/picture/checkPictureCode',
    method: 'post',
    data: data
  });
} // 供应商注册获取验证码

export function getVerificationCode(data) {
  return service({
    url: 'common/mobile/validateCode/get',
    method: 'post',
    data: data
  });
} // 短信验证码确认登录

export function loginByMobile(data, serveUrl) {
  return service({
    url: "byMobileCodeLogin?service=".concat(serveUrl),
    method: 'post',
    data: data
  });
} // 点击用户头像登陆

export function qlogin(data, serveUrl) {
  return service({
    url: '/qlogin/login',
    method: 'post',
    data: data
  });
}